import { render, staticRenderFns } from "./ServiceSpotMessagesClientSelector.vue?vue&type=template&id=60c20eb4&scoped=true"
import script from "./ServiceSpotMessagesClientSelector.vue?vue&type=script&lang=js"
export * from "./ServiceSpotMessagesClientSelector.vue?vue&type=script&lang=js"
import style0 from "./ServiceSpotMessagesClientSelector.vue?vue&type=style&index=0&id=60c20eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c20eb4",
  null
  
)

export default component.exports